import { Component, inject, ViewEncapsulation } from '@angular/core';
import { AccordionModule } from 'primeng/accordion';
import { ActionButtonLabelsForOrderStatus, CartItem, OrderDetails, OrderStatus, OrderStatusProgressOrder } from '../../../constants';
import { DynamicDialogRef, DynamicDialogConfig, DialogService } from 'primeng/dynamicdialog';
import { FirebaseFirestoreService } from '../../../services/firebase.firestore.service';
import { FirebaseStorageService } from '../../../services/firebase.storage.service';
import { CommonModule } from '@angular/common';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { CardModule } from 'primeng/card';
import { Message } from 'primeng/message';
import { DocumentReference } from '@angular/fire/firestore';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ImageModule } from 'primeng/image';
import { UtilityService } from '../../../services/utility.service';
import { TimelineModule } from 'primeng/timeline';

type StringKeyArrayValue<T> = {
  [key: string]: T[];
};

interface EventItem {
    status: string;
    displayStatus: string;
    icon: string;
    completed: boolean;
}

@Component({
    selector: 'app-order-details',
    imports: [
        AccordionModule,
        CommonModule,
        ButtonModule,
        CardModule,
        Message,
        ConfirmDialogModule,
        ImageModule,
        TimelineModule
    ],
    providers: [MessageService, ConfirmationService],
    templateUrl: './order-details.component.html',
    styleUrl: './order-details.component.scss',
    encapsulation: ViewEncapsulation.None
})
export class OrderDetailsComponent {
  dialogService = inject(DialogService);
  dynamicDialogRef = inject(DynamicDialogRef);
  dynamicDialogConfig = inject(DynamicDialogConfig);
  firebaseStorageService = inject(FirebaseStorageService);
  firebaseFirestoreService = inject(FirebaseFirestoreService);
  confirmationService = inject(ConfirmationService);
  utilitiesService = inject(UtilityService);
  
  order: OrderDetails = {} as OrderDetails;
  groupedItems?: StringKeyArrayValue<CartItem>;
  actionButtonLabel = '';
  orderStatus : typeof OrderStatus = OrderStatus;
  loading = false;
  userRole = '';

  events: EventItem[] = [
      { status: this.orderStatus.OrderPlaced, displayStatus: 'Placed', icon: 'pi pi-check-circle', completed: false },
      { status: this.orderStatus.OrderAccepted, displayStatus: 'Accepted', icon: 'pi pi-user', completed: false },
      { status: this.orderStatus.ShoppingInProgress, displayStatus: 'In Progress', icon: 'pi pi-cart-arrow-down', completed: false },
       { status: this.orderStatus.ShoppingCompleted, displayStatus: 'Completed', icon: 'pi pi-shopping-cart', completed: false },
      { status: this.orderStatus.OnTheWay, displayStatus: 'On The Way', icon: 'pi pi-car', completed: false },
      { status: this.orderStatus.Delivered, displayStatus: 'Delivered', icon: 'pi pi-home', completed: false }
  ];
  filteredEvents: EventItem[] = [];
  constructor() {
    const {order, userRole, } = this.dynamicDialogConfig.data;
    this.userRole = userRole;
    this.order = order;
    if(this.order.items?.length) {
      this.processOrderDetails();
    }
    this.firebaseFirestoreService.subscribeToOrderDetails(this.order.orderDocumentRef as DocumentReference, {
      next: (documentSnapshot) => {
        const orderDetails = documentSnapshot.data() as OrderDetails;
        this.order = {
          ...orderDetails,
          orderId: documentSnapshot.id,
          orderDocumentRef: documentSnapshot.ref
        }
        this.processOrderDetails();
        this.updateEventsToShowOnTimeline(orderDetails);
      },
      complete: () => {},
      error: () => {}
    });
  }

  updateEventsToShowOnTimeline(orderDetails: OrderDetails) {
    this.filteredEvents = this.events.filter((event) => {
      if(orderDetails.orderStatus === this.orderStatus.OrderPlaced) {
        return (event.status !== this.orderStatus.ShoppingCompleted && event.status !== this.orderStatus.OnTheWay);
      } else if(orderDetails.orderStatus === this.orderStatus.OrderAccepted) {
        return (event.status !== this.orderStatus.OrderPlaced && event.status !== this.orderStatus.OnTheWay);
      } else if(orderDetails.orderStatus === this.orderStatus.ShoppingInProgress) {
        return (event.status !== this.orderStatus.OrderPlaced && event.status !== this.orderStatus.OnTheWay);
      } else if(orderDetails.orderStatus === this.orderStatus.ShoppingCompleted) {
        return (event.status !== this.orderStatus.OrderPlaced &&event.status !== this.orderStatus.ShoppingInProgress);
      } else if(orderDetails.orderStatus === this.orderStatus.OnTheWay) {
        return (event.status !== this.orderStatus.OrderPlaced &&event.status !== this.orderStatus.ShoppingInProgress);
      } else if(orderDetails.orderStatus === this.orderStatus.Delivered) {
        return (event.status !== this.orderStatus.OrderAccepted &&event.status !== this.orderStatus.ShoppingInProgress);
      }
      return true;
    }).map((event) => {
      return {
        ...event,
        completed: OrderStatusProgressOrder.indexOf(event.status as OrderStatus) <= OrderStatusProgressOrder.indexOf(orderDetails.orderStatus as OrderStatus)
      }
    });
  }

  processOrderDetails() {
    this.groupedItems = this.order.items.reduce((grouped, item) => {
      const key = item.store || 'Any Store';
      if (!grouped[key]) {
        grouped[key] = [];
      }
      grouped[key].push(item);
      return grouped;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    }, {} as any);

    const currentOrderStatusIndex = OrderStatusProgressOrder.findIndex((status) => status === this.order.orderStatus);
    this.actionButtonLabel = ActionButtonLabelsForOrderStatus[currentOrderStatusIndex];

  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  itemsCost(storeReceipts: any[]): number {
    return storeReceipts?.reduce((pre,cur) =>pre +  Number(cur.total), 0) || 0;
  };


  openMaps() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "open-maps", data: {address: this.order.deliveryLocation?.fullAddress}}));
  }

  getDevicePushToken() {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (window as any).ReactNativeWebView?.postMessage(JSON.stringify({action: "get-device-push-token", data: null}));
  }

  closeDialog() {
    this.dynamicDialogRef.close();
  }
}
